import { ButtonLink } from "@ui/ButtonLink";
import { Card } from "@ui/Card";
import { useLayoutAppKindOptional } from "@ui/layouts/layoutProvider";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";

export const FeedbackCard = () => {
	const appKind = useLayoutAppKindOptional();
	const href = () =>
		appKind() === "studio" ? "/studio/feedback" : "/feedback";

	return (
		<Card
			style={{
				"background-color": "rgba(146,65,229,.06)",
				border: "1px solid rgba(146,65,229,.35)",
				padding: "0.75rem 1rem",
			}}
		>
			<VStack spacing="small">
				<HStack spacing="large" align="center">
					<MaterialSymbol symbol="feedback" color="purple" />
					<Text color="fg2">Spotted something off, or missing a feature?</Text>
				</HStack>
				<ButtonLink
					href={href()}
					symbol="arrow_forward"
					symbolPosition="after"
					variant="text"
					class="feedback-button"
				>
					Tell us
				</ButtonLink>
			</VStack>
		</Card>
	);
};
